export default function AboutData() {
    return {
        title: "Personalized Coverage At Your Fingertips",
        content:
            "Experience the most efficient way to purchase life insurance. You can quote, compare and buy in minutes. We'll guide you every step of the way.",
    }
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/Term/AboutData.js